import * as S from "./style";
import { useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
import { Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { addMonths, format } from "date-fns";
//Componentes
import CreditCard from "../CreditCard";
//Icons
import { Plus, Trash } from "@phosphor-icons/react";
//Utils
import { HandleSelectedPayment } from "utils/FunctionPayment";

interface ICreat {
  subtotal: number;
  totalWithDiscount: (total: number) => void;

  register: any;
  errors: any;
  reset: any;
  resetField: any;
  control: any;
  getValues: any;
  watch: any;
  setValue: any;
}

interface IMethPay {
  id: number;
  form_payment: string;
}

export default function CreditStorePayment({
  subtotal,
  totalWithDiscount,
  register,
  errors,
  reset,
  resetField,
  control,
  getValues,
  watch,
  setValue
}: ICreat) {
  const [formPay, setFormPay] = useState<IMethPay[]>([]);
  const [paymentAmount, setPaymentAmount] = useState<number[]>([1]);
  const [formPaymentSelec, setFormPaymentSelec] = useState("");

  const discount = watch("discount") || 0;

  const addPayment = () => {
    if (paymentAmount.length < 6) {
      setPaymentAmount([...paymentAmount, paymentAmount.length + 1]);
    } else {
      alert("Tamanho atingido!");
    }
  };

  const removePayment = (indexToRemove: number) => {
    if (paymentAmount.length > 1) {
      // Atualizar o array de pagamentos
      const updatedPayments = paymentAmount.filter(
        (_, index) => index !== indexToRemove
      );
      setPaymentAmount(updatedPayments);

      // Obter os valores atuais do formulário
      const currentValues = getValues();

      // Verificar se os arrays existem antes de aplicar o filtro
      const updatedAmount = Array.isArray(currentValues.amount)
        ? currentValues.amount.filter(
          (_: any, index: number) => index !== indexToRemove
        )
        : [];
      const updatedDateId = Array.isArray(currentValues.due_date)
        ? currentValues.due_date.filter(
          (_: any, index: number) => index !== indexToRemove
        )
        : [];

      // Atualizar os campos com os valores filtrados
      reset({
        ...currentValues,
        amount: updatedAmount,
        due_date: updatedDateId,
      });
    }
  };

  const ModalSelectedPayment = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const result = HandleSelectedPayment(event);

    if (typeof result === "object") {
      const name = result.name;

      setFormPaymentSelec(name);
    } else {
      console.log("Nenhum pagamento selecionado.");
    }
  };

  const result = subtotal - (subtotal * discount) / 100;
  totalWithDiscount(result);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("form-payment");
        const paymentData = response.data;

        setFormPay(paymentData);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchData();
  }, []);

  /**
   * Data automática
   */

  const generateDueDates = (totalPayments: number) => {
    const today = new Date();
    return Array.from({ length: totalPayments }, (_, index) => {
      const dueDate = addMonths(today, index + 1); // Incrementa os meses
      return format(dueDate, "yyyy-MM-dd"); // Formata para o padrão ISO (ano-mês-dia)
    });
  };

  const totalPayments = paymentAmount.length; // Total de parcelas
  const dueDates = generateDueDates(totalPayments); // Gera as datas automaticamente

  useEffect(() => {
    // Inicializa os valores no formulário
    dueDates.forEach((date, index) => {
      setValue(`due_date.${index}`, date);
    });
  }, [dueDates, setValue]);

  return (
    <S.Container>
      <S.Content>
        <S.SeparateDiv>
          <S.FormInput>
            <S.Label htmlFor="form_payment_id">Forma de Pagamento</S.Label>
            <S.Select
              id="form_payment_id"
              {...register("form_payment_id", { require: true })}
              onChange={(e) => ModalSelectedPayment(e)}
            >
              <option value="" disabled selected hidden>
                Selecione
              </option>
              {formPay.map((val) => {
                const value = val.id;

                return (
                  <option key={value} value={value}>
                    {val.form_payment}
                  </option>
                );
              })}
            </S.Select>
            {errors.form_payment_id && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>

          <S.FormInput>
            <S.Label htmlFor="down_payment">Valor</S.Label>
            <Controller
              name="down_payment"
              control={control}
              rules={{ required: "Campo Obrigatório" }}
              render={({ field: { onChange, value, ref } }) => (
                <NumericFormat
                  className="InputDiscout"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  placeholder="R$ 0,00"
                  prefix="R$ "
                  value={value}
                  onValueChange={(values) => {
                    const purchaseValue = values.floatValue ?? 0;
                    onChange(purchaseValue);
                  }}
                  getInputRef={ref}
                />
              )}
            />
            {errors.down_payment && (
              <S.InforErro>Campo Obrigatório</S.InforErro>
            )}
          </S.FormInput>
        </S.SeparateDiv>

        {formPaymentSelec === "credit-card" && (
          <CreditCard
            register={register}
            errors={errors}
            reset={reset}
            resetField={resetField}
            subtotal={watch("down_payment") || 0}
          />
        )}

        {paymentAmount.map((paymentIndex, index) => (
          <S.ContentPayment key={paymentIndex}>
            <S.SeparateDiv>
              <S.FormInput>
                <S.Label htmlFor="due_date">
                  Data de Vencimento <span>*</span>
                </S.Label>
                <S.Input
                  type="date"
                  {...register(`due_date.${index}`, { require: true })}
                />
                {errors[`due_date.${index}`] && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label htmlFor={`amount.${index}`}>
                  Valor <span>*</span>
                </S.Label>
                <Controller
                  name={`amount.${index}`}
                  rules={{ required: "Campo Obrigatório" }}
                  control={control}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      className="InputDiscout"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue);
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
                {errors[`amount.${index}`] && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
            </S.SeparateDiv>

            {paymentAmount.length > 1 && (
              <S.ContentButton>
                <S.ButtonRemove onClick={() => removePayment(index)}>
                  <Trash />
                  Remover
                </S.ButtonRemove>
              </S.ContentButton>
            )}
          </S.ContentPayment>
        ))}
      </S.Content>

      <S.ContentButton>
        <S.Button onClick={addPayment}>
          <Plus size={16} />
          Parcelas
        </S.Button>

        <S.Infor>{paymentAmount.length} Parcela(s)</S.Infor>
      </S.ContentButton>
    </S.Container>
  );
}
